import { withErrorBoundary } from "@sentry/nextjs";
import { FC } from "react";
import styled from "styled-components";
import { Markdown, ArrowLink } from "components";
import { Introduction1BusinessCardContent, Introduction1IndividualCardContent } from "types/graphql/generated";

interface Props {
  className?: string;
  link:
    | Introduction1BusinessCardContent["linkOne"]
    | Introduction1BusinessCardContent["linkTwo"]
    | Introduction1IndividualCardContent["link"];
  label:
    | Introduction1BusinessCardContent["linkLabelOne"]
    | Introduction1BusinessCardContent["linkLabelTwo"]
    | Introduction1IndividualCardContent["linkLabel"];
  description:
    | Introduction1BusinessCardContent["descriptionOne"]
    | Introduction1BusinessCardContent["descriptionTwo"]
    | Introduction1IndividualCardContent["description"];
}

const CardOption: FC<Props> = withErrorBoundary(({ className = "", link, label, description }) => {
  return (
    <StyledCardOption className={className}>
      <ArrowLink href={link} className="CardOption__link Color_primary Font_24_32_600 md:Font_18_26_600">
        {label}
      </ArrowLink>
      <Markdown className="CardOption__description Color_secondary Font_18_26_450 sm:Font_16_22_450">
        {description}
      </Markdown>
    </StyledCardOption>
  );
}, {});

const StyledCardOption = styled.div`
  .CardOption__link {
    svg {
      width: 16px;
      height: 16px;
    }
  }

  .CardOption__link:hover {
    color: ${({ theme }) => theme.colors.fog["80"]};

    svg {
      fill: ${({ theme }) => theme.colors.fog["80"]};
    }
  }

  .CardOption__description {
    max-width: 392px;
    margin-top: 8px;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.lg}px`}) {
    max-width: unset;

    .CardOption__description {
      max-width: unset;
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    .CardOption__link {
      svg {
        width: 12px;
        height: 12px;
      }
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    &:not(:first-child) {
      margin-top: 24px;
      margin-left: unset;
    }
  }
`;

export { CardOption };
